import React, {useEffect, useState} from "react";
import Layout from "../layout/Layout";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {isCardDesignTemp, isWrapTemp, isGiftMsgTemp, isEGiftMsgTemp} from "../const/TemplateConst";
import WrappingTemplateView from "./WrappingTemplateView";
import "../../style/template/_template.scss";
import GiftMessageTemplateView from "./GiftMessageTemplateView";
import EGiftMessageTemplateView from "./EGiftMessageTemplateView";
import {isNotEmpty} from "../utils/CommonUtil.ts";

const TemplateInputPage: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const fromPage = location.state?.from;
    const [breadcrumbList, setBreadcrumbList] = useState(["注文履歴"]);
    const query = new URLSearchParams(location.search);
    const { kbn } = useParams();
    const [isWrapping, setIsWrapping] = useState(false);
    const [isCardDesign, setIsCardDesign] = useState(false);
    const [isEGiftMsg, setIsEGiftMsg] = useState(false);
    const [isGiftMsg, setIsGiftMsg] = useState(false);
    const [orderNumber, setOrderNumber] = useState<string>("");
    const [orderDetailNumber, setOrderDetailNumber] = useState<number>(0);
    useEffect(() => {
        setIsWrapping(isWrapTemp(kbn));
        setIsCardDesign(isCardDesignTemp(kbn));
        setIsEGiftMsg(isEGiftMsgTemp(kbn));
        setIsGiftMsg(isGiftMsgTemp(kbn));
        const encodedOrderParams = query.get("ord");
        if(encodedOrderParams){
            const decodeParams = decodeURIComponent(encodedOrderParams);
            if(isNotEmpty(decodeParams)){
                const arrOrderInfo = decodeParams.split(";");
                if(arrOrderInfo && arrOrderInfo.length == 2){
                    setOrderNumber(arrOrderInfo[0]);
                    setOrderDetailNumber(parseInt(arrOrderInfo[1]));
                }
            }
        }
    }, []);
    useEffect(()=> {
        setBreadcrumbList(["包装・のしの選択"]);
    }, [isWrapping]);
    useEffect(()=> {
        setBreadcrumbList(["オリジナルギフトカードの入力"]);
    }, [isCardDesign]);
    useEffect(()=> {
        setBreadcrumbList(["オンラインメッセージの入力"]);
    }, [isGiftMsg]);
    useEffect(()=> {
        setBreadcrumbList(["オンラインメッセージの入力"]);
    }, [isEGiftMsg]);
    const handleSavedTemplate = () => {
        if (fromPage){
            navigate(fromPage);
        }else {
            navigate('/template');
        }
    };
    const handleCanceledTemplate = () => {
        if (fromPage){
            navigate(fromPage);
        }else {
            navigate('/template');
        }
    };
  return (
      <Layout page_meta = {{title: 'マイデザイン登録｜ギフトアレンジ'}}
              breadcrumb_list={breadcrumbList}
      >
          {isWrapping &&
              <WrappingTemplateView templateKbn={kbn}
                                    orderNumber={orderNumber}
                                    orderDetailNumber={orderDetailNumber}
                                    handleSaved={handleSavedTemplate}
                                    handleCanceled={handleCanceledTemplate}
              />
          }
          {isGiftMsg &&
              <GiftMessageTemplateView orderNumber={orderNumber}
                                       orderDetailNumber={orderDetailNumber}
                                       handleSaved={handleSavedTemplate}
                                       handleCanceled={handleCanceledTemplate}
              />
          }
          {isEGiftMsg &&
              <EGiftMessageTemplateView orderNumber={orderNumber}
                                        orderDetailNumber={orderDetailNumber}
                                        handleSaved={handleSavedTemplate}
                                        handleCanceled={handleCanceledTemplate}
              />
          }
      </Layout>
  );
};
export default TemplateInputPage;